import React from "react";

export default function LeftArrow({ color = "currentColor" }) {
  return (
    <svg
      width="15"
      height="15"
      viewBox="0 0 36 36"
      fill="none"
      style={{ color }}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M26.5186 6.19863V3.09283C26.5186 2.82363 26.2092 2.67497 26.0003 2.83971L7.88781 16.9866C7.73392 17.1063 7.6094 17.2595 7.52374 17.4346C7.43808 17.6097 7.39355 17.8021 7.39355 17.9971C7.39355 18.192 7.43808 18.3844 7.52374 18.5595C7.6094 18.7346 7.73392 18.8879 7.88781 19.0076L26.0003 33.1544C26.2133 33.3192 26.5186 33.1705 26.5186 32.9013V29.7955C26.5186 29.5986 26.4262 29.4098 26.2735 29.2893L11.8092 17.9991L26.2735 6.70488C26.4262 6.58435 26.5186 6.39551 26.5186 6.19863Z"
        fill={!!color ? color : "black"}
        fillOpacity="0.85"
      />
    </svg>
  );
}
